import { render } from "./Produto.vue?vue&type=template&id=e93efe8c&scoped=true"
import script from "./Produto.vue?vue&type=script&lang=js"
export * from "./Produto.vue?vue&type=script&lang=js"

import "./Produto.vue?vue&type=style&index=0&id=e93efe8c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\natan\\OneDrive\\Code\\Site\\dalena\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e93efe8c"]])

export default __exports__